import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const Export2Icon = forwardRef<SVGSVGElement, IconProps>(function Export2Icon(
  { color = '', height = 12, width = 12, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.02958 2.02958C2.7744 1.28476 3.88895 1 5.32558 1H6.44186C6.67305 1 6.86047 1.18742 6.86047 1.4186C6.86047 1.64979 6.67305 1.83721 6.44186 1.83721H5.32558C3.97152 1.83721 3.13257 2.11059 2.62158 2.62158C2.11059 3.13257 1.83721 3.97152 1.83721 5.32558V8.67442C1.83721 10.0285 2.11059 10.8674 2.62158 11.3784C3.13257 11.8894 3.97152 12.1628 5.32558 12.1628H8.67442C10.0285 12.1628 10.8674 11.8894 11.3784 11.3784C11.8894 10.8674 12.1628 10.0285 12.1628 8.67442V7.55814C12.1628 7.32695 12.3502 7.13953 12.5814 7.13953C12.8126 7.13953 13 7.32695 13 7.55814V8.67442C13 10.1111 12.7152 11.2256 11.9704 11.9704C11.2256 12.7152 10.1111 13 8.67442 13H5.32558C3.88895 13 2.7744 12.7152 2.02958 11.9704C1.28476 11.2256 1 10.1111 1 8.67442V5.32558C1 3.88895 1.28476 2.7744 2.02958 2.02958ZM9.48372 1.4186C9.48372 1.18742 9.67114 1 9.90233 1H12.5814C12.8126 1 13 1.18742 13 1.4186V4.09767C13 4.32886 12.8126 4.51628 12.5814 4.51628C12.3502 4.51628 12.1628 4.32886 12.1628 4.09767V2.42921L7.85414 6.73786C7.69066 6.90133 7.42562 6.90133 7.26214 6.73786C7.09867 6.57438 7.09867 6.30934 7.26214 6.14586L11.5708 1.83721H9.90233C9.67114 1.83721 9.48372 1.64979 9.48372 1.4186Z"
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgStyled>
  );
});
